module.exports = __webpack_public_path__ + "img/project-cover5.bcd4bc8b.png";